import React from 'react'
import Sidebar from "../sidebar/sidebar.js";
import homedashboard from "../../../../assets/images/homedashboard.svg";
import { trendingsection } from "../../../../shared/sliderSetting.js"
import { Trans, useTranslation } from "react-i18next";
import '../dashBoard/dashBoard.model.css';
import { Footer } from '../../../common/footer/footer';
import { MyAdCard } from '../../../common/myAdCard/myAdCard';
import { Pagination } from '../../../common/pagination/uiPagination.js';


import { ArticlesCardJSX } from '../../../common/articlesCard/articlesCard';
import Slider from "react-slick";
const DashBoardJsx = (props) => {
  const {
    blogData,
    offerData,
    onEditButtonClick,
    expertData,
    onDeleteButtonClick,
    onPaginationButtonClick,
    onScrollerChange,
    onPaginationExButtonClick
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <section className="main_institute_dashboard">
        <section className="entiredashboard maincustomerdash main institute_dashboard">

          <div className="container-fluid">
            <div className="row dashboard-decoration">
              <div className="col-lg-4 col-sm-4" style={{ margin: "0px" }}>
                <Sidebar />
              </div>
              <div className="col-lg-8 col-sm-8 dashboard-data-inst">
                <div className="dashboardrightpannerinnerleft dashboardrightpanel">
                  <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={homedashboard} /></span>Home</h2>
                  <div className="leftpad15"><p className="dahsboardTitle">{t("instituteDashboard.HEADING")}</p>
                    <h5 className="dahsboardSubTitle mb-2"><Trans i18nKey={`instituteDashboard.SUBHEADING`}></Trans></h5></div>
                  <section className="offer-list">
                    <Slider {...trendingsection}>
                      {
                        offerData?.length > 0 &&
                        offerData.map((data, index) => (
                          <MyAdCard
                            key={index}
                            data={data}
                            onEditButtonClick={() => onEditButtonClick(data)}
                            onDeleteButtonClick={() => onDeleteButtonClick(data)}
                            onScrollerChange={() => onScrollerChange(data)}
                            fullWidth={true}
                          />
                        ))
                      }
                    </Slider>
                    {/* <OfferCardListJSX
                      SubCatTitle=""
                      SubCatText=""
                      SubCatTextLineOne=""
                      redirectUrl=""
                      offerData={offerData}
                      isDescription={true}
                      isSlider={true}
                      slider={1}
                    /> */}
                  </section>
                  <>{expertData?.length > 0 &&
                    <div className="dashboardblog ">
                      <p className="dahsboardTitle">{t("instituteDashboard.EXPERTAUTHOR")}</p>
                      <p className="dahsboardSubTitle">{t("instituteDashboard.REGISTERED")} </p>
                      <div className="d-none d-sm-block">
                        <div className="expert-all-blog">
                          {
                            expertData?.length > 0 ?
                              expertData?.map(blog => {
                                return <div className={`col-lg-3 col-md-4 col-sm-6 p-0 blogblogmain ${blog?.cats?.[0].name}`} key={blog.id}>
                                  <div className="blog-margin">   <div className={`basicstructure`}>
                                    <ArticlesCardJSX blogslug={blog?.slug}
                                      blogimage={blog?.image}
                                      blogtitle={blog?.title}
                                      articleauthor={blog?.author}
                                      blogcat={blog?.cats?.[0].name}
                                      articledatepublish={blog?.date_publish}

                                      isSerchArticle={false} />

                                  </div>
                                  </div>
                                </div>
                              }) :
                              <div className="empthy-blog">

                                <div>
                                  <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                                </div>
                              </div>
                          }


                        </div>
                      </div>


                      <div className="innerfeaturedblog d-block d-lg-none d-sm-none d-md-none">
                        <div className="expert-all-blog">
                          {
                            expertData?.length > 0 ?
                              expertData?.map(blog => {
                                return <div className={`p-1 blogblogmain smblog ${blog?.cats?.[0].name}`} key={blog.id}>
                                  <div className="blog-margin">   <div className={`basicstructure ${blog?.cats?.[0].name}`}>
                                    <ArticlesCardJSX blogslug={blog?.slug}
                                      blogimage={blog?.image}
                                      blogtitle={blog?.title}
                                      articleauthor={blog?.author}
                                      blogcat={blog?.cats?.[0].name}
                                      articledatepublish={blog?.date_publish}

                                      isSerchArticle={true} />

                                  </div>
                                  </div>
                                </div>
                              }) :
                              <div className="empthy-blog">

                                <div>
                                  <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                                </div>
                              </div>
                          }
                          {expertData?.length > 8 && <section className="newpagination"><Pagination
                            limit={8}
                            totalCount={expertData?.length}
                            onPaginationButtonClick={onPaginationExButtonClick}
                          /></section>}

                        </div>
                      </div>


                    </div>}
                  </>
                  <div className="dashboardblog dashboardexpert">
                    <p className="dahsboardTitle">{t("instituteDashboard.PRODUCTS")}</p>
                    <p className="dahsboardSubTitle">{t("instituteDashboard.PRODUCTSDESC")} </p>
                    <div className="d-none d-sm-block">
                      <div className="expert-all-blog">
                        {
                          blogData?.length > 0 ?
                            blogData?.map(blog => {

                              return <div className={`col-lg-3 col-md-4 col-sm-6 p-0 blogblogmain ${blog.cats[0].name?.replace(/\s+/g, '')}`} key={blog.id}>
                                <div className="blog-margin">   <div className={`basicstructure ${blog.cats[0]?.name}`}>
                                  <ArticlesCardJSX blogslug={blog?.slug}
                                    blogimage={blog?.image}
                                    blogtitle={blog?.title}
                                    articleauthor={blog?.author}
                                    blogcat={blog?.cats?.[0].name}
                                    articledatepublish={blog?.date_publish}
                                    isSerchArticle={false} />

                                </div>
                                </div>
                              </div>

                            }) :
                            <div className="empthy-blog">

                              <div>
                                <h5>{t("instituteDashboard.NOBLOGS")}</h5>

                              </div>
                            </div>

                        }
                      </div>
                    </div>
                    <div className="innerfeaturedblog d-block d-lg-none d-sm-none d-md-none">
                      {
                        blogData?.length > 0 ?
                          blogData?.map(blog => {
                            return <div className={`p-1 smblog ${blog.cats[0].name?.replace(/\s+/g, '')}`} key={blog.id}>
                              <div className={`basicstructure ${blog.cats[0]?.name}`}>
                                <ArticlesCardJSX blogslug={blog?.slug}
                                  blogimage={blog?.image}
                                  blogtitle={blog?.title}
                                  blogcat={blog?.cats.map((cat) => cat.name).join(',')}
                                  articleauthor={blog?.author}
                                  articledatepublish={blog?.date_publish}
                                  isSerchArticle={true} /></div>
                            </div>

                          }) :

                          <div className="dropdefault text-center">
                            <div className="dropdefaultimage">

                            </div>
                            <div className="dropdefaulttext">
                              <h5>You don't have any Blogs yet. </h5>
                            </div>
                          </div>
                      }
                      {blogData?.length > 8 && <section className="newpagination"><Pagination
                        limit={8}
                        totalCount={blogData?.length}
                        onPaginationButtonClick={onPaginationButtonClick}
                      /></section>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>

  );
};

export default DashBoardJsx;
